module.exports = __webpack_public_path__ + "static/media/Profile-photo-Martin-Jr.ce69e34b.jpg";